/** Canonical public host. The live site is served from the apex domain (www redirects here). */
export const SITE_URL = "https://sunsmartengineering.com";

export const SITE_NAME = "SunSmart Engineering";

/** Stable JSON-LD @id values shared by every schema block on the site. */
export const BUSINESS_ID = `${SITE_URL}/#business`;
export const WEBSITE_ID = `${SITE_URL}/#website`;

/** Absolute URL on the canonical host. Already-absolute URLs are returned unchanged. */
export const absoluteUrl = (path: string) =>
  /^https?:\/\//i.test(path) ? path : `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;

/** Kept for existing imports (email/portal link builders). */
export const absUrl = absoluteUrl;

/** Default social share image (1200x630 JPEG in /public). */
export const DEFAULT_OG_IMAGE = absoluteUrl("/og-default.jpg");
